import { ContatosProvider } from "./ContatosContext";
import { ListasProvider } from "./ListasContext";
import { PositionProvider } from "./PositionAtividade";

const DadosProvider = ({ children }) => {
    return (
        <ContatosProvider>
            <ListasProvider>
                <PositionProvider>
                    {children}
                </PositionProvider>
            </ListasProvider>
        </ContatosProvider>
    );
};

export default DadosProvider;